import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { UpdateBijbAccountAction } from '../../actions/current-account/update-account-action';
import { GetCurrentAccountAction } from '../../actions/current-account/get-current-account-action';
import { UpdateBijbAccountErrorAction } from '../../actions/current-account/update-account-error-action';

@Injectable()
export class UpdateBijbAccountEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateEvent = createEffect(() => this.actions
    .pipe(
      ofType(UpdateBijbAccountAction.type),
      mergeMap(action => {
        const updateAccountAction = <UpdateBijbAccountAction>action;
        return this.api.updateAccount(updateAccountAction.bijbAccount).then(() => {
          return new GetCurrentAccountAction();
        }, error => {
          return new UpdateBijbAccountErrorAction(error);
        });
      })
    ));
}
